import { publishMessage } from '@ibinder/ui-common-hooks';

import { ADMIN_EVENT } from './consts';

export const EventLog = async (event: any) => {
  await publishMessage(ADMIN_EVENT.EVENT_LOG, { detail: event });
};
